import { EditorState } from 'prosemirror-state'

import { resolveBlockAt } from './extractBlockInfo'
import { blockInfoPluginKey } from './index'

export function getSpeaker(state: EditorState, pos?: number) {
  const blockInfo = blockInfoPluginKey.getState(state)
  if (pos && blockInfo) {
    return resolveBlockAt(blockInfo, pos)?.speaker
  }
}
